export const PaymentMethod = {
    CASH: 0,
    STRIPE: 1,
    PAYPAL: 2,
}

export const PaymentMethodNames = {
    0: "Cash",
    1: "Credit / Debit card",
    2: "Paypal"
}